/**
 * REV-22155 — one row of the persons Excel export (aumico-be `POST /exporting/persons-xlsx`).
 * Several values in one cell are joined with ", " by the page (e-mails, phones, tags, companies as
 * "Firmenname (Rolle)", deleted companies included without a mark).
 */
export interface IPersonExportDto {
    firstName: string;
    lastName: string;
    street: string;
    additionToAddress: string;
    zip: string;
    city: string;
    email: string;
    phone: string;
    assignee: string;
    clerk: string;
    tags: string;
    companies: string;
}
